import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { CircularProgress, Stack, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloseIcon from "@mui/icons-material/Close";
import { Container } from "@mui/system";
import { useEffect } from "react";
import "./Reminder.css";
import TextField from "@mui/material/TextField";
import { useState, useRef, useContext } from "react";
import CustomerContext from "../../context/customer/CustomerContext";
import AuthContext from "../../context/auth/AuthContext";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { TrackNowTextField, TrackNowSelect } from '../ui';
import CustomDialog from "../common/CustomDialog";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import axios from "axios";
import useDialog from "../common/UseDialog";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import Loader from "../common/Loader";
import { Tooltip, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Fragment } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import UserRoleToolbox from "./UserRoleToolbox";
import UserRoleSetupHistory from "./UserRoleSetupHistory";

import ClientTableFilter from "../customer/ClientTableFilter";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import { GoogleIconButton } from "../ui/GoogleIconButton";
import { ICONS } from "../../constants/icons";
import { TrackNowButton } from '../ui/TrackNowButton';
import { tokens } from "../../theme/tokens";
import { useCommonDetailsContext } from "../../context/Common/common";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: tokens.colors.offWhite,
    color: "#000000",
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: tokens.colors.offWhite,
  },
}));

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;
const SELECT_ALL_CLIENTS_VALUE = "__select_all__";

export default function Reminder() {
  const { publishedBranding, refreshUserRoleAndBranding } = useCommonDetailsContext();
  const tableHeaderColor =
    publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const primaryColor = tableHeaderColor;
  const containerBackgroundColor = tokens.colors.offWhite;
  const tableBackgroundColor = containerBackgroundColor;
  const navigate = useNavigate();

  const authContext = useContext(AuthContext);
  const { authUser, roleType, authId } = authContext;

  const customerContext = useContext(CustomerContext);
  const { UserList, setUserList } = customerContext;

  const [isSave, setIsSave] = useState(true);
  const [formValues, setFormValues] = useState({});
  const [existingCompanyList, setExistingCompanyList] = useState([])
  const [customerList, setCustomerList] = useState([]);
  const [parentCustomerList, setParentCustomerList] = useState([]);
  const [clientSearchText, setClientSearchText] = useState("");
  const [userRoleList, setUserRoleList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [selectedUserRole, setSelectedUserRole] = useState(null);
  const [alertMessage, setAlertMessage] = React.useState(null)
  const [showAlert, setShowAlert] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState();
  const [isLoadingDataTable, setIsLoadingDataTable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFilterValues, setSelectedFilterValues] = useState({});
  const [activityHistory, setActivityHistory] = React.useState([]);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [refreshRecordList, setRefreshRecordList] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(null);
  const [recordsInView, setRecordsInView] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [headerRecordCount, setHeaderRecordCount] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [selectedUserRow, setSelectedUserRow] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });


  const isBrandingRoleIncludes = Array.isArray(roleType)
    ? roleType.includes("BrandAdministrator") || roleType.includes("BrandAdministrator-PostAward")
    : false;

  const [filters, setFilters] = useState({
    userName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    loginId: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    clientName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    roleName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    notificationMail: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  });
  const isJsitelEmail = /@jsitel(\.[A-Za-z0-9-]+)+$/i.test(
    formValues.loginEmail
  );

  const isBrandAdminRole = () => {
    return (
      formValues.role?.name === "BrandAdministrator" ||
      formValues.role?.name === "BrandAdministrator-PostAward"
    );
  };

  const isClientRole = () => {
    return (
      formValues.role &&
      formValues.role.name &&
      (formValues.role.name === "ClientAdmin" ||
        formValues.role.name === "ClientUser" ||
        formValues.role.name === "JSIPOC" ||
        formValues.role.name === "HierarchyAdmin" ||
        formValues.role.name === "ClientAdmin-PostAward" ||
        formValues.role.name === "ClientUser-PostAward" ||
        formValues.role.name === "JSIPOC-PostAward" ||
        formValues.role.name === "HierarchyAdmin-PostAward" ||
        formValues.role.name === "ClientReadOnly" ||
        formValues.role.name === "ClientReadOnly-PostAward" ||
        formValues.role.name === "BrandAdministrator" ||
        formValues.role.name === "BrandAdministrator-PostAward"

      )
    );
  };

  const isAdminRole = () => {
    return (
      formValues.role &&
      formValues.role.name &&
      (formValues.role.name === "Admin" ||
        formValues.role.name === "Admin-PostAward")
    );
  };

  const activeClientOptions = isBrandAdminRole() ? parentCustomerList : customerList;

  const EditButton = ({ rowData }) => {
    return (
      <GoogleIconButton
        iconName={ICONS.edit}
        iconColor={primaryColor}
        onClick={() => editUserRole(rowData)}
        sx={{
          '&:hover': { backgroundColor: `${primaryColor}1A` },
          '& .MuiTouchRipple-root .MuiTouchRipple-child': { backgroundColor: primaryColor },
        }}
      />
    );
  };

  const editUserRole = async (data) => {
    console.log("editUserRole", data, formValues);
    const roleListUser = await axios.get(
      `${API_BASE_URL}/Application/ListUsersRolesByUserwithRole?UserId=${data.userId}&roleid=${data.roleId}`
    );
    setExistingCompanyList(roleListUser.data.data)
    setIsSave(false);
    setSelectedUserRole(data);
    setFormValues({
      userName: data.userName,
      loginEmail: data.loginId,
      client: normalizeClientSelection(
        roleListUser.data.data
          .filter((cust) => cust.customerId !== null)
          .map((cust) => ({
            code: cust.customerId,
            name: cust.customerName,
          }))
      ),
      includeNotification: data.notificationMail,
      role: data.roleId ? { code: data.roleId, name: data.roleName } : "",
    });
  };

  const DeleteButton = ({ rowData }) => {
    return (
      <GoogleIconButton
        iconName={ICONS.delete}
        iconColor={primaryColor}
        onClick={() => handleDelete(rowData)}
        sx={{
          '&:hover': { backgroundColor: `${primaryColor}1A` },
          '& .MuiTouchRipple-root .MuiTouchRipple-child': { backgroundColor: primaryColor },
        }}
      />
    );
  };

  const handleConfigItemChange = (event) => {
    console.log("handleConfigItemChange", event);
    const { name, value } = event.target;
    setFormValues((prevValues) => {
      const nextValues = {
        ...prevValues,
        [name]: value,
      };

      if (name === "role") {
        const wasBrandAdmin =
          prevValues.role?.name === "BrandAdministrator" ||
          prevValues.role?.name === "BrandAdministrator-PostAward"

        const isNowBrandAdmin =
          value?.name === "BrandAdministrator" ||
          value?.name === "BrandAdministrator-PostAward"


        if (wasBrandAdmin !== isNowBrandAdmin) {
          nextValues.client = [];
        }
      }
      return nextValues;
    });
  };

  const normalizeClientSelection = (clients) => {
    const list = Array.isArray(clients) ? clients : clients ? [clients] : [];
    const combinedLookup = [...customerList, ...parentCustomerList];
    const byCode = new Map(combinedLookup.map((client) => [client.code, client]));
    const deduped = new Map();

    list.forEach((item) => {
      const code = typeof item === "object" ? item.code : item;
      if (code === undefined || code === null) {
        return;
      }

      const canonical =
        byCode.get(code) || (typeof item === "object" ? item : null);

      if (canonical) {
        deduped.set(code, canonical);
      }
    });

    return Array.from(deduped.values());
  };

  const handleClientChange = (event) => {
    const value = event?.target?.value ?? event?.value;

    if (isBrandAdminRole()) {
      const selectedCode = typeof value === "object" ? value?.code : value;
      const normalized = normalizeClientSelection(selectedCode ? [selectedCode] : []);
      setFormValues((prevValues) => ({
        ...prevValues,
        client: normalized,
      }));
      return;
    }

    const selectedValues = Array.isArray(value) ? value : [];

    if (selectedValues.includes(SELECT_ALL_CLIENTS_VALUE)) {
      const nextValue = areAllClientsSelected
        ? []
        : customerList.map((client) => client.code);

      const normalizedAllClients = normalizeClientSelection(nextValue);
      setFormValues((prevValues) => ({
        ...prevValues,
        client: normalizedAllClients,
      }));
      return;
    }

    const selectedCodes = selectedValues.filter(
      (item) => item !== SELECT_ALL_CLIENTS_VALUE
    );
    const normalized = normalizeClientSelection(selectedCodes);
    setFormValues((prevValues) => ({
      ...prevValues,
      client: normalized,
    }));
  };

  const selectedClientCodes = normalizeClientSelection(formValues.client).map(
    (client) => client.code
  );

  const areAllClientsSelected =
    customerList.length > 0 && selectedClientCodes.length === customerList.length;

  const isPartiallySelected =
    selectedClientCodes.length > 0 && !areAllClientsSelected;

  const handleClearClients = (event) => {
    event.preventDefault();
    event.stopPropagation();

    handleClientChange({
      target: {
        name: "client",
        value: isBrandAdminRole() ? "" : [],
      },
    });
  };

  const renderClientValue = (selected) => {
    const normalized = normalizeClientSelection(selected);

    if (!normalized || normalized.length === 0) {
      return <span style={{ color: "#9E9E9E" }}>Select Client</span>;
    }

    const names = normalized.map((item) => item.name).filter(Boolean);
    const visibleNames = names.slice(0, 3);
    const primaryLabel = visibleNames.join(", ");
    const moreCount = names.length - visibleNames.length;

    return (
      <Box
        component="span"
        sx={{
          display: "flex",
          alignItems: "center",
          overflow: "hidden",
          minWidth: 0,
          pr: 0.5,
          maxWidth: "100%",
          width: "100%",
        }}
      >
        <Box
          component="span"
          sx={{
            minWidth: 0,
            flex: "1 1 0",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            overflow: "hidden",
            maxWidth: "calc(100% - 28px)",
          }}
        >
          <Box
            component="span"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              minWidth: 0,
              flex: "1 1 auto",
              maxWidth: "100%",
            }}
          >
            {primaryLabel}
            {moreCount > 0 ? "..." : ""}
          </Box>
          {moreCount > 0 && (
            <Box
              component="span"
              sx={{
                flex: "0 0 auto",
                whiteSpace: "nowrap",
              }}
            >
              {`+${moreCount} more`}
            </Box>
          )}
        </Box>
        <Box
          component="span"
          onMouseDown={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
          onClick={handleClearClients}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "0 0 18px",
            width: 18,
            ml: 0.5,
            mr: 0.25,
            color: tokens.colors.grey,
            cursor: "pointer",
            "&:hover": {
              color: primaryColor,
            },
          }}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </Box>
      </Box>
    );
  };

  const refreshTableData = async (resetFilters = false) => {
    if (resetFilters) {
      setActiveFilters([]);
      setIsFilterChange([]);
    }
    setIsLoadingDataTable(true);
    setRecordsInView(1);
    setRefreshDetails(null);
    if (dt.current) {
      try {
        const vScroll = dt.current.getVirtualScroller();
        if (vScroll) {
          vScroll.scrollToIndex(0);
        }
      } catch (e) {
        console.error("vScroll reset error", e);
      }
    }
    await loadRecordsList(0, pageSize, "down", resetFilters ? [] : undefined);
    setIsLoadingDataTable(false);
  };

  const handleReset = () => {
    setFormValues({
      userName: "",
      client: null,
      loginEmail: "",
      includeNotification: "",
      role: "",
    });
    setExistingCompanyList([]);
    setIsSave(true);
    setIsFormSubmitted(false);
  };

  // const isValidEmail = (email) => {
  //   return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+\.com$/i.test(email);
  // };
  const isValidEmail = (email) => {
    return (
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/.test(email) &&
      !email.includes("..")
    );
  };

  const handleSave = async () => {
    setIsLoading(true);
    setIsFormSubmitted(true);

    try {
      // Validate required fields
      const hasRequired =
        !formValues.userName ||
        !formValues.loginEmail ||
        !isValidEmail(formValues.loginEmail) ||
        typeof formValues.includeNotification !== "boolean" ||
        !formValues.role ||
        (
          [
            "JSIUser",
            "JSIPOC",
            "JSISME",
            "JSIReadOnly",
            "JSIUser-PostAward",
            "JSIPOC-PostAward",
            "JSISME-PostAward",
            "JSIReadOnly-PostAward",
          ].includes(formValues.role?.name) &&
          !/@jsitel(\.[A-Za-z0-9-]+)+$/i.test(formValues.loginEmail)
        ) ||
        (isClientRole() && !formValues.client?.length);  // Check if client array is empty

      if (hasRequired) {
        setIsLoading(false);
        return;
      }

      // Check if email already exists
      const isExist = userRoleList.filter(ele =>
        formValues.loginEmail === ele.loginId
      );

      if (
        isClientRole() &&
        !formValues.client?.length  // Check if client array is empty
      ) {
        setIsLoading(false);
        return;
      }
      console.log("handleSave", "BrandAdministrator", formValues, authUser, isBrandingRoleIncludes);

      //check id branding admin roles already assifned to logged user ID
      if ((formValues.role.name === "BrandAdministrator" || formValues.role.name === "BrandAdministrator-PostAward") &&
        formValues.loginEmail === authUser?.loginId &&
        isBrandingRoleIncludes) {
        setAlertMessage("Customer already assigned to Branding role for selected user");
        setShowAlert(true);
        setIsLoading(false);
        return;
      }


      if (refreshUserRoleAndBranding) {
        await refreshUserRoleAndBranding();
      }


      // If user exists and no validation errors, update their role
      if (isExist.length > 0 && !hasRequired) {
        await createUsersRoles(isExist[0].userId);
        return;
      }

      // If no validation errors, create new user
      if (!hasRequired) {

        let payload = {
          userId: 0,
          userName: formValues.userName,
          loginId: formValues.loginEmail,
          notificationMail: formValues.includeNotification,
          // customerId: formValues.client ? formValues.client.code : null,
          createDate: new Date(Date.now()).toISOString(),
          createUser: authUser.userId + "",
        };
        console.log("payload", payload);


        let res = await axios.post(
          `${API_BASE_URL}/Application/CreateUsers`,
          payload
        );

        if (res.data.status === "Failure") {
          setAlertMessage(res.data.errorMessage);
          setShowAlert(true);
        } else {
          await createUsersRoles(res.data.data.userId);
        }
      }
    } catch (error) {
      console.error("Error in handleSave:", error);
      setAlertMessage("An error occurred while saving");
      setShowAlert(true);
    } finally {
      setIsLoading(false);

    }
  };
  const createUsersRoles = async (userId) => {
    console.log("createUsersRoles userId", userId, formValues.client);
    try {

      const payload = Array.isArray(formValues.client) && formValues.client.length > 0
        ? formValues.client.map((client) => ({
          userId: userId,
          roleId: formValues.role ? formValues.role.code : null,
          customerId: client?.code || null,
          notificationMail: formValues.includeNotification,
          createDate: new Date(Date.now()).toISOString(),
          createUser: authUser.userId + "",
        }))
        : [
          {
            userId: userId,
            roleId: formValues.role ? formValues.role.code : null,
            customerId: null,
            notificationMail: formValues.includeNotification,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          },
        ];
      console.log("createUsersRoles payload", payload);
      let res = await axios.post(
        `${API_BASE_URL}/Application/CreateUsersRoles`,
        payload
      );
      console.log("res", res);

      const globalErrors = res.data?.errorMessages;

      if (Array.isArray(globalErrors) && globalErrors.length > 0) {
        setAlertMessage(globalErrors);
        setShowAlert(true);
      } else if (res.data?.status === "Failure" || res.data?.isSuccess === false) {
        setAlertMessage(res.data?.errorMessage || "Something went wrong");
        setShowAlert(true);
      } else {
        setAlertMessage("User role added successfully");
        setShowAlert(true);
      }
      setIsFormSubmitted(false);
      handleReset();
      setActiveFilters([]);
      setIsFilterChange([]);
      await refreshTableData(true);
      if (refreshUserRoleAndBranding) {
        await refreshUserRoleAndBranding();
      }
      await getCustomerList();
      await getParentCustomerList();

    } catch (error) {
      console.log(error);
    }
  };

  const createBrandingDefaultConfiguration = async () => {
    const payload = {
      customerId: formValues.client[0].code,
      primaryColor: "#001a77",
      backgroundColor: "#001a77",
      fontFamily: "Roboto",
      isDefault: true,
      logoDataUrl: "",
      userId: String(authUser?.userId ?? ""),
      userName: authUser?.userName || authUser?.loginId || "",
      createUser: String(authUser?.userId ?? ""),
    };

    console.log("CreateBrandingConfiguration payload:", payload);
    await axios.post(
      `${API_BASE_URL}/Application/CreateBrandingConfiguration`,
      payload
    );
  }

  const compareClientLists = (existingCompanyList, formValuesClient) => {
    const create = [];
    const update = [];
    const remove = [];

    const existingIds = new Set(existingCompanyList.map((c) => c.customerId));
    const formValuesArray = Array.isArray(formValuesClient) ? formValuesClient : [];
    const formValuesIds = new Set(formValuesArray.map((c) => c.code));

    // Handle single client replacement when editing an existing role (1 existing company -> 1 new selected company)
    if (existingCompanyList.length === 1 && formValuesArray.length === 1 && existingCompanyList[0].customerId !== formValuesArray[0].code) {
      return {
        create: [],
        update: [formValuesArray[0].code],
        delete: [],
        isSingleReplacement: true,
        targetCustomerCode: formValuesArray[0].code
      };
    }

    // Create & Update
    formValuesArray.forEach((client) => {
      if (!existingIds.has(client.code)) {
        create.push(client.code);
      } else {
        update.push(client.code);
      }
    });

    // Delete
    if (formValuesArray.length === 0) {
      existingCompanyList.forEach((client) => {
        if (client.userRoleId !== selectedUserRole.userRoleId) {
          remove.push(client.userRoleId); // remove if not matching
        }
      });
    }
    else {
      existingCompanyList.forEach((client) => {
        if (!formValuesIds.has(client.customerId)) {
          remove.push(client.userRoleId);
        }
      });
    }


    return {
      create,
      update,
      delete: remove,
    };
  };


  const handleUpdate = async () => {
    setIsLoading(true);
    setIsFormSubmitted(true);
    console.log("handleUpdate formVal", formValues);
    console.log("handleUpdate existing value", existingCompanyList);
    console.log("handleUpdate selectedUserRole", selectedUserRole);
    try {
      function checkisOtherFieldChange(formValues, selectedUserRoles) {
        let isOtherFieldChange = false;
        let isNotificationChange = false;

        // Treat undefined and "" as equivalent
        if (
          !(
            (formValues?.client?.length === 0 &&
              selectedUserRoles.clientName === "") ||
            formValues?.client?.some(
              (clientObj) => clientObj.name === selectedUserRoles?.clientName
            )
          )
        ) {
          isOtherFieldChange = true;
        }

        if (
          formValues.includeNotification !== selectedUserRoles.notificationMail
        ) {
          isNotificationChange = true;
        }

        if (formValues.role?.code !== selectedUserRoles.roleId) {
          isOtherFieldChange = true;
        }
        if (formValues.userName !== selectedUserRoles.userName) {
          isOtherFieldChange = true;
        }
        if (formValues.loginEmail !== selectedUserRoles.loginId) {
          isOtherFieldChange = true;
        }

        return !isOtherFieldChange && isNotificationChange;
      }

      // Example usage

      const isOnlyNotificationChange = await checkisOtherFieldChange(
        formValues,
        selectedUserRole
      );

      // Outputs: true or false
      console.log(
        "handleUpdate isOnlyNotificationChange",
        isOnlyNotificationChange
      );

      let hasRequired =
        !formValues.userName ||
        !formValues.loginEmail ||
        !(
          formValues.includeNotification === false ||
          formValues.includeNotification === true
        ) ||
        ([
          "JSIUser",
          "JSIPOC",
          "JSISME",
          "JSIReadOnly",
          "JSIUser-PostAward",
          "JSIPOC-PostAward",
          "JSISME-PostAward",
          "JSIReadOnly-PostAward",
        ].includes(formValues.role?.name) &&
          !isJsitelEmail) ||
        !formValues.role;

      if (
        isClientRole() &&
        (!Array.isArray(formValues.client) || formValues.client.length === 0)
      ) {
        console.log("handleUpdate Client name is required", formValues);
        return;
      }

      const effectiveExistingCompanyList = (selectedUserRole && formValues.role?.code !== selectedUserRole.roleId)
        ? existingCompanyList.filter((company) => company.userRoleId === selectedUserRole.userRoleId)
        : existingCompanyList;

      const result = compareClientLists(effectiveExistingCompanyList, formValues.client);
      console.log("handleUpdate result", result);

      if (!hasRequired) {
        let resUpdateUser = null;
        if (!isOnlyNotificationChange) {
          let payload = {
            userId: selectedUserRole.userId,
            userName: formValues.userName,
            loginId: formValues.loginEmail,
            //notificationMail: formValues.includeNotification,
            //customerId: formValues.client ? formValues.client.code : null,
            updateDate: new Date(Date.now()).toISOString(),
            updateUser: authUser.userId + "",
          };

          console.log("handleUpdate payload", payload);
          resUpdateUser = await axios.put(
            `${API_BASE_URL}/Application/UpdateUsers/${selectedUserRole.userId}`,
            payload
          );
          console.log("res", resUpdateUser.data);
        }
        console.log("handleUpdate res", selectedUserRole, formValues);

        const clientCodes = formValues.client?.map((client) => client.code) || [];
        const existingCustomerIds = effectiveExistingCompanyList.map((company) => company.customerId);

        const isClientMismatch =
          clientCodes.length !== existingCustomerIds.length ||
          clientCodes.some((code) => !existingCustomerIds.includes(code));
        console.log("isClientMismatch", isClientMismatch, clientCodes, existingCustomerIds);

        if (
          selectedUserRole.roleId !== formValues.role?.code ||
          (formValues.client === undefined && selectedUserRole.customerId) ||
          isClientMismatch ||
          formValues.includeNotification !== selectedUserRole.notificationMail
        ) {
          await updateUsersRoles(result);
        }
        else {
          setAlertMessage("User role successfully updated");
          setShowAlert(true);
          handleReset();
          setActiveFilters([]);
          setIsFilterChange([]);
          await refreshTableData(true);
          if (refreshUserRoleAndBranding) {
            await refreshUserRoleAndBranding();
          }
          await getCustomerList();
          await getParentCustomerList();
        }

        if (refreshUserRoleAndBranding) {
          await refreshUserRoleAndBranding();
        }

      }
    } catch (error) {
      console.error("errorUPD", error);
    } finally {

      setIsLoading(false);
    }
  };

  const updateUsersRoles = async (result) => {
    try {
      let updatePayload = [];

      if (Array.isArray(result.update) && result.update.length > 0) {
        console.log("result.update", result.update, existingCompanyList);
        if (result.isSingleReplacement) {
          updatePayload = [
            {
              ...selectedUserRole,
              userRoleId: selectedUserRole.userRoleId,
              userId: selectedUserRole.userId,
              roleId: formValues.role?.code || null,
              customerId: result.targetCustomerCode || null,
              updateDate: new Date(Date.now()).toISOString(),
              updateUser: authUser.userId + "",
              notificationMail: formValues.includeNotification,
            }
          ];
        } else {
          const matchedCompanies = existingCompanyList.filter((company) =>
            result.update.includes(company.customerId)
          );
          console.log("matchedCompanies", matchedCompanies, result.update);

          updatePayload = matchedCompanies.map((item) => ({
            ...item,
            userId: item.userId,
            roleId: formValues.role?.code || null,
            customerId: item.customerId || null,
            updateDate: new Date(Date.now()).toISOString(),
            updateUser: authUser.userId + "",
            notificationMail: formValues.includeNotification,
          }));
        }
      } else if (!isClientRole() || !formValues.client || (Array.isArray(formValues.client) && formValues.client.length === 0)) {
        // Default payload with customerId as null ONLY for non-client roles or when no client is selected
        updatePayload = [
          {
            ...selectedUserRole,
            userId: selectedUserRole.userId,
            roleId: formValues.role?.code || null,
            customerName: null,
            customerId: null,
            updateDate: new Date(Date.now()).toISOString(),
            updateUser: authUser.userId + "",
            notificationMail: formValues.includeNotification,
          },
        ];
      }



      // console.log("res", res);

      let createPayload = [];

      if (Array.isArray(result.create) && result.create.length > 0) {
        createPayload = result.create.map((customerId) => ({
          userId: selectedUserRole.userId,
          roleId: formValues.role?.code || null,
          customerId: customerId || null,
          notificationMail: formValues.includeNotification,
          createDate: new Date(Date.now()).toISOString(),
          createUser: authUser.userId + "",
        }));
      }
      let deletePayLoad = []
      if (Array.isArray(result.delete) && result.delete.length > 0) {
        deletePayLoad = result.delete
      }


      let isFailure = false;
      let errorMessage = "";
      let hasError = false;

      if (updatePayload.length > 0) {
        const resUpdate = await axios.put(`${API_BASE_URL}/Application/UpdateUsersRoles`, updatePayload);
        errorMessage = resUpdate.data.errorMessages || [];
        const rawData = resUpdate.data.data;
        const respList = Array.isArray(rawData) ? rawData : (typeof rawData === 'string' ? JSON.parse(rawData) : []);
        const hasFailedItem = Array.isArray(respList) && respList.some(item => item.status === "Failure");
        const isApiFailure = resUpdate.data?.status === "Failure" || resUpdate.data?.errorCode > 0;

        if (isApiFailure || hasFailedItem) {
          hasError = true;
        }
      }

      if (createPayload.length > 0) {
        const resCreate = await axios.post(`${API_BASE_URL}/Application/CreateUsersRoles`, createPayload);
        errorMessage = resCreate.data.errorMessages || [];
        const rawData = resCreate.data.data;
        const respList = Array.isArray(rawData) ? rawData : (typeof rawData === 'string' ? JSON.parse(rawData) : []);
        const hasFailedItem = Array.isArray(respList) && respList.some(item => item.status === "Failure");
        const isApiFailure = resCreate.data?.status === "Failure" || resCreate.data?.errorCode > 0;

        if (isApiFailure || hasFailedItem) {
          hasError = true;
        }
      }

      if (!hasError && deletePayLoad.length > 0) {
        const resDelete = await axios.delete(`${API_BASE_URL}/Application/DeleteUsersRoles`, {
          data: deletePayLoad,
        });
        if (resDelete.data.status === "Failure") {
          isFailure = true;
          errorMessage = resDelete.data.errorMessage;
        }
      }

      setAlertMessage(errorMessage.length > 0 ? errorMessage : "User role updated successfully");
      setShowAlert(true);
      handleReset();
      setActiveFilters([]);
      setIsFilterChange([]);
      await refreshTableData(true);
      if (refreshUserRoleAndBranding) {
        await refreshUserRoleAndBranding();
      }
      await getCustomerList();
      await getParentCustomerList();

    } catch (error) {
      console.log(error);
    }
  };

  const deleteUser = async () => {
    setIsLoadingDataTable(true);
    console.log("deleteUser data", selectedUser);
    try {
      let res = await axios.delete(
        `${API_BASE_URL}/Application/DeleteUsers/${selectedUser.userId}`
      );
      console.log("res", res.data);
      if (res.data.status === "Success") {
        await deleteUserRole();
      } else if (res.data.status === "Failure") {
        console.log("Stats#", res.data.errorMessage);
        setAlertMessage(
          `Unable to delete this ${selectedUser.userName}. The ${selectedUser.userName} is assigned as a default approver in Approval Config. page. If you want to delete, please change the approver.`
        );
        setShowAlert(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingDataTable(false);
    }
  };

  const deleteUserRole = async () => {
    console.log("deleteUserRole userRoleId", selectedUser?.userRoleId);
    const delPayload = [selectedUser?.userRoleId];
    try {
      let res = await axios.delete(
        `${API_BASE_URL}/Application/DeleteUsersRoles`,
        { data: delPayload }
      );
      console.log("res", res);
      if (res) {
        setAlertMessage("User role successfully deleted");
        setShowAlert(true);
        handleReset();
        setActiveFilters([]);
        setIsFilterChange([]);
        await refreshTableData(true);
        if (refreshUserRoleAndBranding) {
          await refreshUserRoleAndBranding();
        }
        await getCustomerList();
        await getParentCustomerList();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const { AlertDialog: ConfirmDialog, showDialog } = useDialog({
    onSubmit: deleteUserRole,
  });

  const handleDelete = (data) => {
    console.log("handleDelete data", data);
    setSelectedUser(data);
    showDialog(
      "Confirmation",
      "Are you sure you want to delete this user?",
      "confirm"
    );
  };

  const getClientName = (clientId) => {
    const combinedLookup = [...customerList, ...parentCustomerList];
    let findName = combinedLookup.filter((ele) => ele.code === clientId);
    return findName.length > 0 ? findName[0].name : "";
  };

  const cellClientName = (rowData) => {
    console.log("cellClientName", rowData);
    return getClientName(rowData.customerId);
  };

  const closeAlert = () => {
    setShowAlert(false);
  };

  useEffect(() => {
    console.log("isAdminRole changed", isAdminRole(), formValues);
    if (isAdminRole()) {
      console.log("isAdminRole clear client");
      setFormValues((prevValues) => ({
        ...prevValues,
        client: null,
      }));
    }
  }, [formValues.role]);

  const getConfigs = async () => {
    setIsLoadingDataTable(true);

    console.log("@@Fetch getConfigs");
    try {
      let roles = await axios.get(`${API_BASE_URL}/Application/ListRoles`);
      console.log("getConfigs res", roles.data.data);
      roles = roles.data.data.map((ele) => ({
        name: ele.roleName,
        code: ele.roleId,
      }));
      console.log("getConfigs roles", roles, roleType);

      setRoleList(roles);
    } catch (error) {
      console.log("@@getConfigs Error:", error);
    } finally {
      setIsLoadingDataTable(false);
    }
  };

  useEffect(() => {
    console.log("customerList", customerList);
    if (customerList.length > 0) {
      getConfigs();
      setRecordsInView(0);
      setIsLoadingDataTable(true);
      setUserRoleList([]);
      setIsFilterChange([]);
      setSelectedFilterValues({});
      setRefreshRecordList(true);
    }
  }, [customerList]);

  useEffect(() => {
    if (!customerList.length) {
      return;
    }

    if (!Array.isArray(formValues.client) || formValues.client.length === 0) {
      return;
    }

    const normalized = normalizeClientSelection(formValues.client);
    const isSame =
      normalized.length === formValues.client.length &&
      normalized.every((client, index) => client === formValues.client[index]);

    if (!isSame) {
      setFormValues((prevValues) => ({
        ...prevValues,
        client: normalized,
      }));
    }
  }, [customerList]);

  const getCustomerList = async () => {
    try {
      const isAdminUser = Boolean(roleType?.includes("Admin") || roleType?.includes("Admin-PostAward"));

      const res = await axios.get(`${API_BASE_URL}/Customer/CustomerList`, {
        params: {
          ...(!isAdminUser ? { UserID: authId } : {})
        }
      });
      let _data;
      _data = res.data.map((ele) => ({
        code: ele.customerId,
        name: ele.customerName,
      }));
      console.log("getCustomerList _data", _data);

      _data = _data.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });

      setCustomerList(_data);
    } catch (error) {
      //console.log("getCustomerList error", error);
    }
  };

  const getParentCustomerList = async () => {
    try {
      const resParentList = await axios.get(
        `${API_BASE_URL}/Customer/ParentCustomersList`
      );
      let list = Array.isArray(resParentList.data?.data)
        ? resParentList.data.data
        : Array.isArray(resParentList.data)
          ? resParentList.data
          : [];

      let _data = list.map((ele) => ({
        code: ele.customerId ?? ele.code ?? ele.parentCustomerId ?? ele.id,
        name: ele.customerName ?? ele.name ?? ele.parentCustomerName,
      }));

      _data = _data.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      setParentCustomerList(_data);
    } catch (error) {
      console.error("getParentCustomerList error", error);
    }
  };

  const displayWarning = async () => {
    console.log("createUsersRoles ");
    try {
      let res = await axios.get(
        `${API_BASE_URL}/Customer/ListCustomersWithNullJSIPoc`
      );
      console.log("res", res);
      if (res.data.status === "Failure") {
        setAlertMessage(res.data.errorMessage);
        setShowAlert(true);
      } else {
        setAlertMessage({ warningDisplay: true, data: res.data });
        setShowAlert(true);
      }
    } catch (error) {
      console.lo(error);
    }
  };

  useEffect(() => {
    getCustomerList();
    getParentCustomerList();
  }, []);



  const dt = useRef(null);
  const headerCountRequestRef = useRef(0);
  const pageSize = 100;

  // lazy load function
  const loadDataLazy = async (event) => {
    console.log("loadDataLazy props", recordsInView, event);

    //Virtual scroll callback
    const vScroll = dt.current.getVirtualScroller();

    let range = vScroll.getRenderedRange();
    let { first, last } = range.viewport;
    console.log("loadDataLazy vScroll", vScroll, range.viewport);

    let firstVal = recordsInView * pageSize;
    let tableList = userRoleList;
    console.log(
      "loadDataLazy totalRecords",
      firstVal,
      totalRecords,
      lazyLoading,
      tableList.length
    );

    console.log(
      "loadDataLazy",
      firstVal < totalRecords,
      first > tableList.length - 10,
      !lazyLoading
    );

    if (
      firstVal < totalRecords &&
      first > tableList.length - 10 &&
      !lazyLoading
    ) {
      //scroll down
      setLazyLoading(true);
      let lastVal = firstVal + pageSize;
      console.log("loadDataLazy d firstVal", firstVal, lastVal);

      //get next data
      let records = await loadRecordsList(firstVal, lastVal, "down");
      console.log("loadDataLazy d record", records);
      if (records) {
        console.log("loadDataLazy d scrollInView", recordsInView * 100);

        //scroll to next records
        vScroll.scrollInView(recordsInView * 100);
        setRecordsInView((old) => old + 1);
        setLazyLoading(false);
        setIsLoadingDataTable(false);
      }
    } else if (last < 10 && recordsInView > 1 && !lazyLoading) {
      // scroll up
      let firstVal = (recordsInView - 3) * pageSize;
      let lastVal = firstVal + pageSize;
      if (firstVal >= 0) {
        setLazyLoading(true);
        // console.log("loadDataLazy u firstVal", firstVal, lastVal);

        //get prev data
        let records = await loadRecordsList(firstVal, lastVal, "up");
        // console.log("loadDataLazy u record", records);
        if (records) {
          // console.log("loadDataLazy u scrollInView", (recordsInView - 3) * 100);

          //scroll to prev records
          vScroll.scrollToIndex(15);
          setRecordsInView((old) => old - 1);
          setLazyLoading(false);
          setIsLoadingDataTable(false);
        }
      }
    }
  };

  const loadRecordsList = async (first, last, direction, overrideFilters) => {
    // console.log("loadRecordsList props", first, last, direction);
    setIsLoadingDataTable(true);
    const activeFiltersForRequest =
      overrideFilters !== undefined ? overrideFilters : isFilterChange;
    const filterSnapshot = JSON.stringify(activeFiltersForRequest || []);
    const headerCountRequestId =
      first === 0 ? ++headerCountRequestRef.current : headerCountRequestRef.current;
    let url = `${API_BASE_URL}/Application/ListUsersRolesByPagination?StartRow=${first + 1
      }&EndRow=${last}`;

    // console.log("loadRecordsList fliter/sort", activeFiltersForRequest, sortingData);
    if (activeFiltersForRequest !== undefined && activeFiltersForRequest.length > 0) {
      // url filter parameters
      activeFiltersForRequest.forEach((ele) => {
        url = `${url}&${ele.name}=${ele.val}${ele.searchType ? `&${ele.searchType}=${ele.searchTypeVal}` : ``
          }`;
      });
    }

    if (
      sortingData &&
      typeof sortingData === "object" &&
      sortingData.sortBy !== "" &&
      sortingData.sortOrder !== ""
    ) {
      // url sort parameters
      let sortParameter = getSortData(sortingData.sortBy);
      console.log("getSortData", sortParameter);
      let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";

      url = `${url}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
    }

    // console.log("loadRecordsList url", url);
    try {
      //get data
      const res = await axios.get(url);
      console.log("loadRecordsList res", res);

      // console.log("loadRecordsList res", res.data, res.data.items);

      if (res.data) {
        setIsLoadingDataTable(true);
        const ogList =
          first === 0
            ? []
            : Array.isArray(userRoleList)
              ? userRoleList.map((ele) => ele)
              : [];
        await modifyList(res.data.items, direction, ogList, first);
        setTotalRecords(res.data.totalItems);
        if (first === 0) {
          const snapshotFilters = JSON.parse(filterSnapshot || "[]");
          const hasActiveFilters =
            Array.isArray(snapshotFilters) && snapshotFilters.length > 0;

          if (!hasActiveFilters) {
            if (headerCountRequestId !== headerCountRequestRef.current) {
              return res.data.items;
            }
            setHeaderRecordCount(res.data.items.length);
          } else {
            // Fallback immediately so UI updates quickly.
            setHeaderRecordCount(res.data.items.length);

            // Fetch a larger filtered window to derive an accurate visible count
            // for the header without relying on TotalItems behavior.
            let countUrl = `${API_BASE_URL}/Application/ListUsersRolesByPagination?StartRow=1&EndRow=5000`;
            snapshotFilters.forEach((ele) => {
              countUrl = `${countUrl}&${ele.name}=${ele.val}${ele.searchType ? `&${ele.searchType}=${ele.searchTypeVal}` : ``
                }`;
            });

            const countRes = await axios.get(countUrl);
            if (
              countRes?.data?.items &&
              headerCountRequestId === headerCountRequestRef.current
            ) {
              setHeaderRecordCount(countRes.data.items.length);
            }
          }
        }

        return res.data.items;
      } else {
        return false;
      }
    } catch (err) {
      // console.log("loadRecordsList err", err);
    }
  };

  //maping records for lazy load
  const modifyList = (list, direction, ogList, first = 0) => {
    console.log("modifyList", list, direction);
    if (list.length > 0) {
      //list has data
      const updList = list.map((ele, i) => ({
        ...ele,
        clientName: getClientName(ele.customerId),
        userListId: `${i}${ele.userRoleId}`,
      }));

      let tableList = Array.isArray(userRoleList) ? userRoleList : [];
      console.log("modifyList updCustomers", updList, tableList);

      let updUserList = updList;
      if (first === 0) {
        // Any fresh fetch (new filter/sort/search baseline) should replace stale rows.
        updUserList = updList;
      } else if (direction === "down") {
        //scroll down
        if (tableList.length >= 200) {
          //list > 200

          //slice 2 half of list
          let unloadList = ogList.slice(
            ogList.length - pageSize,
            ogList.length
          );
          // console.log("modifyList dw unloadList", unloadList);

          //add new data
          updUserList = [...unloadList, ...updList];
          // console.log("modifyList dw updUserList", updUserList);
        } else {
          //list < 200

          // add new data to list
          updUserList = [...ogList, ...updList];
          // console.log("modifyList dw updUserList", updUserList);
        }
      } else if (direction === "up") {
        //scroll up
        if (tableList.length >= 200) {
          //list > 200

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updUserList = [...updList, ...unloadList];
          // console.log("modifyList up updUserList", updUserList);
        } else {
          //list < 200

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          console.log("modifyList up unloadList", unloadList);

          //add new data
          updUserList = [...updList, ...unloadList];
          console.log("modifyList up updUserList", updUserList);
        }
      }

      setUserRoleList(() => updUserList);
      setUserList(updUserList);
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoadingDataTable(false);
      return updUserList;
    } else {
      //list empty
      // console.log("modifyList empty",list)
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoadingDataTable(false);
      setUserList([]);
      return [];
    }
  };

  const onFilterChange = async (e) => {
    console.log("onFilterChange props", e.filters);
    let filterChange = [];
    //map filter event
    Object.keys(e.filters).forEach((col) => {
      // console.log("onFilterChange col", col, e.filters[col]);
      if (
        e.filters[col].constraints &&
        e.filters[col].constraints[0].value !== null
      ) {
        if (col === "loginId") {
          filterChange.push({
            name: `SearchByLoginEmail`,
            val: e.filters[col].constraints[0].value,
            searchType: `LoginEmailSearchType`,
            searchTypeVal: getSearchType(
              e.filters[col].constraints[0].matchMode
            ),
          });
        } else if (col === "notificationMail") {
          const notificationApiValue = getNotificationApiValue(
            e.filters[col].constraints[0].value,
            e.filters[col].constraints[0].matchMode
          );
          if (notificationApiValue !== null) {
            filterChange.push({
              name: `SearchByNotificationInclude`,
              val: notificationApiValue,
            });
          }
        } else {
          filterChange.push({
            name: `SearchBy${col}`,
            val: e.filters[col].constraints[0].value,
            searchType: `${col}SearchType`,
            searchTypeVal: getSearchType(
              e.filters[col].constraints[0].matchMode
            ),
          });
        }
      }
    });
    console.log("onFilterChange filterChange", filterChange);

    //set filter
    handleSetFilterVariable(filterChange);
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return matchModeVal.find((ele) => ele.name === matchMode).val;
  };

  //set filter
  const handleSetFilterVariable = (filterChange) => {
    console.log("handleSetFilterVariable props", filterChange);
    setIsFilterChange(() => filterChange);
    setRecordsInView(0);
    setIsLoadingDataTable(true);
    setUserRoleList([]);
  };

  const handleSort = async (e) => {
    console.log("handleSort props", e, e.sortField);
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
      setRecordsInView(0);
      setIsLoadingDataTable(true);
      setUserRoleList([]);
    }
  };

  const getSortData = (val) => {
    console.log("getSortData props", val);
    if (val === "federalCategories" || val === "stateCategories") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "BusinessCategory",
        SortOrderParameter: "SortOrder",
      };
    } else if (val === "awardType") {
      return {
        SortByParameter: "SortByAwardType",
        SortByVal: "AwardType",
        SortOrderParameter: "SortOrderAwardType",
      };
    } else if (val === "awardingAgency") {
      return {
        SortByParameter: "SortByAwardingAgency",
        SortByVal: "AwardingAgency",
        SortOrderParameter: "SortOrderAwardingAgency",
      };
    } else {
      return {
        SortByParameter: "SortBy",
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        SortOrderParameter: "SortOrder",
      };
    }
  };

  useEffect(() => {
    // console.log("filter/sort change", isFilterChange, sortingData, lazyLoading );
    //on filter/sort change
    if (!lazyLoading && !refreshRecordList) {
      setLazyLoading(true);
      const sortAndFilterApiCall = async () => {
        let records = await loadRecordsList(0, 100, "down");
        setRecordsInView(1);
        console.log("recordsCheck", records);
        setIsLoadingDataTable(false);
      };
      sortAndFilterApiCall();
    }
  }, [isFilterChange, sortingData]);

  const refreshRecords = async () => {
    console.log("refreshRecords");

    let records;
    console.log("refreshRecords refreshDetails", refreshDetails);
    if (refreshDetails?.pageInView || refreshDetails?.noOfPages) {
      let first = refreshDetails.pageInView * pageSize;
      records = await loadRecordsList(
        first,
        first + refreshDetails?.noOfPages * pageSize,
        "down"
      );
    } else {
      records = await loadRecordsList(0, pageSize, "down");
    }

    if (records) {
      if (refreshDetails?.viewport && refreshDetails?.noOfPages) {
        console.log(
          "refreshRecords scrollInView",
          refreshDetails.viewport.first,
          dt
        );
        setRecordsInView((old) => old + refreshDetails?.noOfPages);
        setRefreshDetails(null);
      } else {
        setRecordsInView((old) => old + 1);
      }
    }
  };
  const fetchFilingMasterHistory = async (userRoleId) => {
    console.log("fetchFilingMasterHistory props", userRoleId);
    try {
      let res = await axios.get(
        `${API_BASE_URL}/Application/UserRolesAudit?UserRoleId=${userRoleId}`
      );
      let history = res.data.data;

      setActivityHistory(() => history);
      console.log("fetchFilingMasterHistory res", history);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const displayHomePage = () => {
    navigate("/");
  };
  const displayTrackNowFilingMasterList = () => {
    navigate("/filing-master-list");
  };
  const displayPostAwardFilingMasterList = () => {
    navigate("/postaward-filing-master-list");
  };
  const displayClientFilingTrackerList = () => {
    navigate("/client-filing-tracker-list");
  };

  const closeHistory = () => {
    // console.log("Toggling Show Filter", showHistory);
    setShowHistory(() => false);
  };
  const displayHistory = async () => {
    console.log("displayHistory", selectedUserRow);
    if (selectedUserRow && selectedUserRow.userRoleId) {
      console.log(`Fetching History for :${selectedUserRow.userRoleId}`);
      fetchFilingMasterHistory(selectedUserRow.userRoleId);
      setShowHistory(() => true);
    } else {
      setAlertMessage("Please Select a user");
      setShowAlert(true);
      // closeDialog();
    }
  };
  useEffect(() => {
    console.log("refreshRecordList,", refreshRecordList, !lazyLoading);
    if (refreshRecordList && !lazyLoading) {
      setLazyLoading(true);
      refreshRecords();
    }
  }, [refreshRecordList]);

  useEffect(() => {
    console.log("Total Records updated:", totalRecords);
  }, [totalRecords]);

  useEffect(() => {
    console.log("recordsInView,", recordsInView);
  }, [recordsInView]);

  useEffect(() => {
    console.log("userRoleList,", userRoleList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRoleList, userRoleList.length, JSON.stringify(userRoleList)]);

  useEffect(() => {
    // console.log("UserList,", UserList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UserList]);

  useEffect(() => {
    console.log("isLoading", isLoading);
  }, [isLoading]);

  useEffect(() => {
    console.log("lazyLoading", lazyLoading);
  }, [lazyLoading]);

  const normalizeNotificationFilterValue = (value) => {
    const values = (Array.isArray(value) ? value : [value])
      .map((entry) => {
        if (typeof entry === "boolean") {
          return entry;
        }
        if (typeof entry === "string") {
          const lowered = entry.trim().toLowerCase();
          if (lowered === "true") {
            return true;
          }
          if (lowered === "false") {
            return false;
          }
        }
        if (entry === 1 || entry === "1") {
          return true;
        }
        if (entry === 0 || entry === "0") {
          return false;
        }
        return null;
      })
      .filter((entry) => entry !== null);

    const hasTrue = values.includes(true);
    const hasFalse = values.includes(false);

    if (!hasTrue && !hasFalse) {
      return null;
    }
    if (hasTrue && hasFalse) {
      return null;
    }

    return hasTrue;
  };

  const getNotificationApiValue = (value, matchMode) => {
    const normalizedValue = normalizeNotificationFilterValue(value);
    if (normalizedValue === null) {
      return null;
    }

    const effectiveValue =
      matchMode === FilterMatchMode.NOT_CONTAINS
        ? !normalizedValue
        : normalizedValue;

    return effectiveValue ? "True" : "False";
  };

  const buildApiFiltersFromActiveFilters = (filterList) => {
    let apiFilters = [];

    filterList.forEach((filter) => {
      if (filter.field === "loginId") {
        apiFilters.push({
          name: `SearchByLoginEmail`,
          val: filter.value,
          searchType: `LoginEmailSearchType`,
          searchTypeVal: getSearchType(filter.matchMode),
        });
      } else if (filter.field === "notificationMail") {
        const notificationApiValue = getNotificationApiValue(
          filter.value,
          filter.matchMode
        );
        if (notificationApiValue !== null) {
          apiFilters.push({
            name: `SearchByNotificationInclude`,
            val: notificationApiValue,
          });
        }
      } else {
        apiFilters.push({
          name: `SearchBy${filter.field}`,
          val: filter.value,
          searchType: `${filter.field}SearchType`,
          searchTypeVal: getSearchType(filter.matchMode),
        });
      }
    });

    return apiFilters;
  };

  const handleSelect = (e) => {
    // console.log("handleSelect e", e);
    setSelectedUserRow(e.value);
  };

  const applyNewFilter = (filterConfig) => {
    console.log("applyNewFilter", filterConfig);

    const columnLabels = {
      userName: "User Name",
      loginId: "Login Email",
      clientName: "Client Name",
      roleName: "Role",
      notificationMail: "Include Notification?"
    };

    const normalizedNotificationValue =
      filterConfig.field === "notificationMail"
        ? normalizeNotificationFilterValue(filterConfig.value)
        : undefined;

    const newFilter = {
      field: filterConfig.field,
      label: columnLabels[filterConfig.field],
      displayValue:
        filterConfig.field === "notificationMail"
          ? normalizedNotificationValue === null
            ? []
            : [normalizedNotificationValue ? "True" : "False"]
          : Array.isArray(filterConfig.value)
            ? filterConfig.value
            : [filterConfig.value],
      matchMode: filterConfig.matchMode,
      value:
        filterConfig.field === "notificationMail"
          ? normalizedNotificationValue
          : filterConfig.value
    };

    const updatedFilters = activeFilters.filter((f) => f.field !== filterConfig.field);
    if (filterConfig.field === "notificationMail" && normalizedNotificationValue === null) {
      setActiveFilters(updatedFilters);
      handleSetFilterVariable(buildApiFiltersFromActiveFilters(updatedFilters));
      return;
    }

    const nextActiveFilters = [...updatedFilters, newFilter];
    setActiveFilters(nextActiveFilters);
    handleSetFilterVariable(buildApiFiltersFromActiveFilters(nextActiveFilters));
  };

  const removeFilter = (index) => {
    const updatedFilters = activeFilters.filter((_, i) => i !== index);
    setActiveFilters(updatedFilters);
    handleSetFilterVariable(buildApiFiltersFromActiveFilters(updatedFilters));
  };

  const clearAllFilters = () => {
    setActiveFilters([]);
    setIsFilterChange([]);
    setRecordsInView(0);
    setIsLoadingDataTable(true);
    setUserRoleList([]);
    setRefreshRecordList(true);
  };

  console.log("formValues", formValues);

  return (
    <Fragment>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          px: 2,
          overflowX: "hidden"

        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "1300px",
            mx: "auto",
          }}
        >          <div
          style={{
            borderRadius: "8px",
            boxShadow: "none",
            backgroundColor: containerBackgroundColor,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            width: "100%",
            marginTop: "1rem",
            overflow: "visible",
            border: "none",
          }}
        >
            {isLoading && <Loader />}
            <React.Fragment>
              <Box sx={{ padding: "30px" }}>
                <Stack direction="column">
                  <Stack direction="row" justifyContent="space-between">
                    <div>
                      <Typography sx={{ fontWeight: "bold", ml: "1rem" }}>
                        User Role Setup
                      </Typography>
                    </div>
                    <IconButton color="warning">
                      <WarningAmberIcon onClick={() => displayWarning()} />
                    </IconButton>
                  </Stack>

                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={3}
                    sx={{ mt: 2 }}
                  >
                    <Box sx={{ width: { xs: "100%", md: "50%" }, pr: { md: 2 } }}>
                      <Stack direction="column" spacing={2}>
                        <Stack>
                          <TrackNowTextField
                            id="userName"
                            name="userName"
                            label="User Name"
                            placeholder="Enter User Name"
                            fullWidth
                            value={formValues.userName}
                            onChange={handleConfigItemChange}
                            required
                            error={isFormSubmitted && !formValues.userName}
                            helperText={
                              isFormSubmitted && !formValues.userName
                                ? "User Name is required"
                                : ""
                            }
                          />
                        </Stack>

                        <Stack direction="row" spacing={3}>
                          <div style={{ width: "100%" }}>
                            <TrackNowSelect
                              name="client"
                              value={
                                isBrandAdminRole()
                                  ? normalizeClientSelection(formValues.client)[0]?.code || ""
                                  : normalizeClientSelection(formValues.client).map(
                                    (client) => client.code
                                  )
                              }
                              onChange={handleClientChange}
                              onClose={() => setClientSearchText("")}
                              label="Client"
                              required={isClientRole()}
                              multiple={!isBrandAdminRole()}
                              disabled={isAdminRole()}
                              renderValue={renderClientValue}
                              fullWidth
                              displayEmpty
                              MenuProps={{
                                variant: "menu",
                                autoFocus: false,
                                disableAutoFocusItem: true,
                                PaperProps: {
                                  sx: {
                                    maxHeight: 320,
                                  },
                                },
                                MenuListProps: {
                                  autoFocusItem: false,
                                },
                              }}
                              error={
                                isFormSubmitted &&
                                isClientRole() &&
                                (!formValues.client || formValues.client.length === 0)
                              }
                              helperText={
                                isFormSubmitted &&
                                  isClientRole() &&
                                  (!formValues.client || formValues.client.length === 0)
                                  ? "Please select client"
                                  : ""
                              }
                            >
                              <MenuItem
                                disableRipple
                                style={{
                                  backgroundColor: "transparent",
                                  cursor: "default",
                                  paddingTop: 0,
                                  paddingBottom: "8px",
                                }}
                                onKeyDown={(e) => e.stopPropagation()}
                              >
                                <TextField
                                  placeholder="Search Clients..."
                                  size="small"
                                  fullWidth
                                  value={clientSearchText}
                                  onChange={(e) => setClientSearchText(e.target.value)}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </MenuItem>
                              {!isBrandAdminRole() && (
                                <MenuItem
                                  value={SELECT_ALL_CLIENTS_VALUE}
                                >
                                  <Checkbox
                                    checked={areAllClientsSelected}
                                    indeterminate={isPartiallySelected}
                                    size="small"
                                    sx={{
                                      mr: 1,
                                      color: tokens.colors.midGrey,
                                      '&.Mui-checked': {
                                        color: primaryColor,
                                      },
                                      '&.MuiCheckbox-indeterminate': {
                                        color: primaryColor,
                                      },
                                      '&:hover': {
                                        backgroundColor: `${primaryColor}1A`,
                                      },
                                    }}
                                  />
                                  <ListItemText primary="Select All" />
                                </MenuItem>
                              )}
                              {activeClientOptions
                                .filter((option) =>
                                  !clientSearchText ||
                                  option.name?.toLowerCase().includes(clientSearchText.toLowerCase())
                                )
                                .map((option) => {
                                  const isSelected = selectedClientCodes.includes(option.code);

                                  return (
                                    <MenuItem key={option.code} value={option.code}>
                                      {isBrandAdminRole() ? (
                                        <RadioButton
                                          checked={isSelected}
                                          value={option.code}
                                          onChange={() => { }}
                                          style={{ marginRight: "10px" }}
                                        />
                                      ) : (
                                        <Checkbox
                                          checked={isSelected}
                                          size="small"
                                          sx={{
                                            mr: 1,
                                            color: tokens.colors.midGrey,
                                            '&.Mui-checked': {
                                              color: primaryColor,
                                            },
                                            '&.MuiCheckbox-indeterminate': {
                                              color: primaryColor,
                                            },
                                            '&:hover': {
                                              backgroundColor: `${primaryColor}1A`,
                                            },
                                          }}
                                        />
                                      )}
                                      <ListItemText primary={option.name} />
                                    </MenuItem>
                                  );
                                })}
                            </TrackNowSelect>
                          </div>
                        </Stack>
                      </Stack>
                    </Box>

                    <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                      <Stack>
                        <TrackNowTextField
                          id="loginEmail"
                          name="loginEmail"
                          label="Login Email"
                          placeholder="Enter Login Email"
                          fullWidth
                          disabled={!isSave}
                          value={formValues.loginEmail}
                          onChange={handleConfigItemChange}
                          inputProps={{
                            maxLength: 40,
                          }}
                          required
                          error={
                            (isFormSubmitted && !formValues.loginEmail) ||
                            (isFormSubmitted &&
                              formValues.loginEmail &&
                              !isValidEmail(formValues.loginEmail)) ||
                            (isFormSubmitted &&
                              isValidEmail(formValues.loginEmail) &&
                              !isJsitelEmail &&
                              [
                                "JSIUser",
                                "JSIPOC",
                                "JSISME",
                                "JSIReadOnly",
                                "JSIUser-PostAward",
                                "JSIPOC-PostAward",
                                "JSISME-PostAward",
                                "JSIReadOnly-PostAward",
                              ].includes(formValues.role?.name))
                          }
                          helperText={
                            isFormSubmitted && !formValues.loginEmail
                              ? "Login Email is required"
                              : isFormSubmitted &&
                                formValues.loginEmail &&
                                !isValidEmail(formValues.loginEmail)
                                ? "Please enter a valid email address"
                                : isFormSubmitted &&
                                  isValidEmail(formValues.loginEmail) &&
                                  !isJsitelEmail &&
                                  [
                                    "JSIUser",
                                    "JSIPOC",
                                    "JSISME",
                                    "JSIReadOnly",
                                    "JSIUser-PostAward",
                                    "JSIPOC-PostAward",
                                    "JSISME-PostAward",
                                    "JSIReadOnly-PostAward",
                                  ].includes(formValues.role?.name)
                                  ? "Please enter JSI Staff email ID for JSI roles."
                                  : ""
                          }
                        />
                      </Stack>
                      <Stack direction="row" spacing={3}>
                        <div style={{ width: "100%", marginTop: "1rem" }}>
                          <TrackNowSelect
                            name="role"
                            label="Role"
                            required
                            value={formValues.role || ""}
                            onChange={handleConfigItemChange}
                            fullWidth
                            displayEmpty
                            error={isFormSubmitted && !formValues.role}
                            helperText={isFormSubmitted && !formValues.role ? "Please select role" : ""}
                            renderValue={(selected) => {
                              if (!selected || !selected.name) {
                                return <span style={{ color: '#9E9E9E' }}>Select Role</span>;
                              }
                              return selected.name;
                            }}
                          >
                            {roleList.map((option) => (
                              <MenuItem key={option.code} value={option}>
                                {option.name}
                              </MenuItem>
                            ))}
                          </TrackNowSelect>
                        </div>
                        <div style={{ width: "100%", marginTop: "1rem" }}>
                          <Typography>Include Notification?</Typography>
                          <Stack
                            className="user-role-notification-radios"
                            direction="row"
                            spacing={3}
                            sx={{ mt: 1 }}
                          >
                            <div
                              className="flex align-items-center"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <RadioButton
                                inputId="yes"
                                name="includeNotification"
                                value={true}
                                onChange={(e) => {
                                  console.log("includeNotification value", e);
                                  handleConfigItemChange(e);
                                }}
                                checked={
                                  formValues.includeNotification === true
                                }
                              />
                              <label
                                htmlFor="yes"
                                style={{ marginLeft: "1rem" }}
                              >
                                Yes
                              </label>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <RadioButton
                                inputId="no"
                                name="includeNotification"
                                value={false}
                                onChange={(e) => {
                                  console.log(
                                    "includeNotification value",
                                    e.value
                                  );
                                  handleConfigItemChange(e);
                                }}
                                checked={
                                  formValues.includeNotification === false
                                }
                              />
                              <label
                                htmlFor="no"
                                style={{ marginLeft: "1rem" }}
                              >
                                No
                              </label>
                            </div>
                          </Stack>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              fontWeight: "small",
                              marginTop: "1rem",
                              color: "red",
                              display:
                                isFormSubmitted &&
                                  !(
                                    formValues.includeNotification === true ||
                                    formValues.includeNotification === false
                                  )
                                  ? "block"
                                  : "none",
                            }}
                          >
                            Please select notification
                          </Typography>
                        </div>
                      </Stack>
                    </Box>
                  </Stack>
                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={3}
                    sx={{ mt: 2 }}
                    justifyContent="flex-end"
                    width="100%"
                  >
                    <TrackNowButton
                      variant="tertiary"
                      onClick={handleReset}
                    >
                      Reset
                    </TrackNowButton>
                    {isSave ? (
                      <TrackNowButton
                        variant="primary"
                        onClick={handleSave}
                      >
                        Save
                      </TrackNowButton>
                    ) : (
                      <TrackNowButton
                        variant="primary"
                        onClick={handleUpdate}
                      >
                        Update
                      </TrackNowButton>
                    )}
                  </Stack>
                </Stack>
              </Box>
            </React.Fragment>
            <style>{`
  .p-datatable.user-role-setup-table {
    border-radius: 8px !important;
    overflow: hidden !important;
    border: none !important;
    box-shadow: none !important;
    background: ${tableBackgroundColor} !important;
  }

  .user-role-setup-table .p-datatable-wrapper {
    border-radius: 8px !important;
    overflow: hidden !important;
    background: ${tableBackgroundColor} !important;
    border: none !important;
  }

  .user-role-setup-table .p-datatable-header {
    background: ${tableBackgroundColor} !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .user-role-setup-table .p-datatable-table {
    border-radius: 8px !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  /* HEADER */
  .user-role-setup-table .p-datatable-thead > tr {
    background: ${tableHeaderColor} !important;
  }

  .user-role-setup-table .p-datatable-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px !important;
  }

  .user-role-setup-table .p-datatable-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px !important;
  }

  .user-role-setup-table .p-datatable-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 8px !important;
  }

  .user-role-setup-table .p-datatable-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 8px !important;
  }

  .user-role-setup-table .p-datatable-thead > tr > th {
    background: transparent !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0.02em !important;
    padding: 12px 16px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-bottom: none !important;
    text-transform: none !important;
    box-shadow: none !important;
  }

  .user-role-setup-table .p-datatable-thead > tr > th:last-child {
    border-right: none !important;
  }

  .user-role-setup-table .p-sortable-column-icon {
    color: #ffffff !important;
  }

  .user-role-setup-table .p-datatable-tbody {
    background: ${tableBackgroundColor} !important;
  }

  .user-role-setup-table .p-virtualscroller-content {
    background: ${tableBackgroundColor} !important;
  }

  /* ROWS - Alternating colors with gridlines */
  .user-role-setup-table .p-datatable-tbody > tr {
    height: 45px !important;
  }

  .user-role-setup-table .p-datatable-tbody > tr:nth-child(odd) > td {
    background-color: ${tableBackgroundColor} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  .user-role-setup-table .p-datatable-tbody > tr:nth-child(even) > td {
    background-color: ${tableBackgroundColor} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  /* FORCE PURPLE BORDERS ON ALL CELLS */
  .user-role-setup-table .p-datatable-tbody > tr > td {
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
    border-left: none !important;
    border-top: none !important;
  }

  .user-role-setup-table .p-datatable-tbody > tr > td:last-child {
    border-right: none !important;
  }

  /* SELECTED ROW */
  .user-role-setup-table .p-datatable-tbody > tr.p-highlight > td {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  .p-checkbox .p-checkbox-box.p-highlight {
    background: ${tableHeaderColor} !important;
    border-color: ${tableHeaderColor} !important;
  }

  .user-role-notification-radios .p-radiobutton:not(.p-disabled) .p-radiobutton-box:hover {
    border-color: ${tableHeaderColor} !important;
  }

  .user-role-notification-radios .p-radiobutton .p-radiobutton-box.p-focus,
  .user-role-notification-radios .p-radiobutton.p-focus .p-radiobutton-box {
    border-color: ${tableHeaderColor} !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${tableHeaderColor} 25%, white) !important;
  }

  .user-role-notification-radios .p-radiobutton .p-radiobutton-box.p-highlight,
  .user-role-notification-radios .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
    border-color: ${tableHeaderColor} !important;
    background: ${tableHeaderColor} !important;
  }

  .user-role-setup-table .p-radiobutton:not(.p-disabled) .p-radiobutton-box:hover {
    border-color: ${tableHeaderColor} !important;
  }

  .user-role-setup-table .p-radiobutton .p-radiobutton-box.p-focus,
  .user-role-setup-table .p-radiobutton.p-focus .p-radiobutton-box {
    border-color: ${tableHeaderColor} !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${tableHeaderColor} 25%, white) !important;
  }

  .user-role-setup-table .p-radiobutton .p-radiobutton-box.p-highlight,
  .user-role-setup-table .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
    border-color: ${tableHeaderColor} !important;
    background: ${tableHeaderColor} !important;
  }

  /* SCROLLBAR */
  .p-datatable-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb {
    background: #C0BEC2;
    border-radius: 10px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
    background: ${tableHeaderColor};
  }
`}</style>
            <Box
              sx={{
                borderRadius: "8px",
                boxShadow: "none",
                backgroundColor: containerBackgroundColor,
                display: "flex",
                flexDirection: "column",
                width: "100%",
                overflow: "visible",
                border: "none",
              }}
            >
              <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', padding: '0 1rem' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start', flex: 1 }}>
                  <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    sx={{
                      fontWeight: 500,
                      color: "inherit",
                      textDecoration: "none",
                    }}
                  >
                    USER ROLE CONFIGURATIONS
                  </Typography>
                  <Box sx={{ alignSelf: "flex-start", display: "inline-flex" }}>
                    <TrackNowButton
                      variant="secondary"
                      onClick={(e) => setFilterAnchorEl(e.currentTarget)}
                    >
                      + Filter
                    </TrackNowButton>
                  </Box>
                  {activeFilters.length > 0 && (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
                      {activeFilters.map((filter, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: containerBackgroundColor,
                            border: '1px solid #ccc',
                            borderRadius: '20px',
                            padding: '6px 12px',
                            fontSize: '13px',
                            color: '#333',
                          }}
                        >
                          {filter.label}:{" "}
                          {Array.isArray(filter.displayValue)
                            ? filter.displayValue.join(", ")
                            : filter.displayValue}
                          <button
                            type="button"
                            onClick={() => removeFilter(index)}
                            style={{
                              marginLeft: '6px',
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              fontSize: '16px',
                            }}
                          >
                            &times;
                          </button>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              </div>
              <Box sx={{ px: "1rem", pb: "1rem" }}>
                <DataTable
                  className="user-role-setup-table"
                  scrollable
                  showGridlines
                  dataKey="userListId"
                  value={UserList}
                  filters={filters}
                  filterMode="multiple"
                  selection={selectedUserRow}
                  onSelectionChange={(e) => handleSelect(e)}
                  loading={isLoadingDataTable}
                  tableStyle={{
                    minWidth: "50rem",
                  }}
                  ref={dt}
                  virtualScrollerOptions={{
                    onScroll: loadDataLazy,
                    itemSize: 45,
                    delay: 0,
                    scrollHeight: "550px",
                    appendOnly: true,
                  }}
                  scrollHeight="550px"
                  onFilter={(e) => onFilterChange(e)}
                // sortField={sortingData.sortBy}
                // sortOrder={sortingData.sortOrder}
                // onSort={(e) => handleSort(e)}
                >
                  <Column
                    selectionMode="single"
                    //headerStyle={{ width: "3rem" }}
                    style={{ width: "1rem", margin: "0" }}
                  >
                    Select
                  </Column>
                  <Column
                    field="userName"
                    header="User Name"
                  ></Column>
                  <Column
                    field="loginId"
                    header="Login Email"
                  ></Column>
                  <Column
                    field="clientName"
                    header="Client Name"
                    body={(rowData) => (
                      <>
                        {rowData.clientName && rowData.clientName.length > 35 ? (
                          <LightTooltip title={rowData.clientName} arrow>
                            <span>{rowData.clientName.substring(0, 35)}...</span>
                          </LightTooltip>
                        ) : (
                          rowData.clientName
                        )}
                      </>
                    )}
                  ></Column>
                  <Column
                    field="roleName"
                    header="Role"
                  ></Column>
                  <Column
                    field="notificationMail"
                    header="Include Notification?"
                  ></Column>
                  <Column
                    style={{ textAlign: "center" }}
                    body={(rowData) => (
                      <>
                        <Stack direction="row">
                          <EditButton rowData={rowData} />
                          <DeleteButton rowData={rowData} />
                        </Stack>
                      </>
                    )}
                  ></Column>
                </DataTable>
              </Box>
            </Box>
            <ClientTableFilter
              anchorEl={filterAnchorEl}
              onClose={() => setFilterAnchorEl(null)}
              onApply={applyNewFilter}
              onClear={clearAllFilters}
              clients={UserList}
              categoriesLookup={[]}
              programList={[]}
              stateList={[]}
              tracknowlicenseTypes={[]}
              postawardlicenseTypes={[]}
              roleType={roleType}
              key={activeFilters.length}
              userRoleMode={true}
              roleList={roleList}
              customerList={customerList}
            />
          </div>
          <ConfirmDialog />
          <CustomDialog
            header="Info"
            visible={showAlert}
            onHide={closeAlert}
            footer={null}
          >
            {alertMessage?.warningDisplay ? (
              <div
                style={{
                  maxWidth: "460px",
                  margin: "0 auto",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    marginBottom: "18px",
                    textAlign: "center",
                    fontSize: "18px",
                    color: "#5f6368",
                    lineHeight: 1.5,
                  }}
                >
                  JSI POC not configured for the following clients
                </p>

                <ul
                  style={{
                    margin: 0,
                    paddingLeft: "24px",
                    textAlign: "left",
                    lineHeight: 1.8,
                  }}
                >
                  {alertMessage?.data.map((ele) => (
                    <li
                      key={ele}
                      style={{
                        marginBottom: "4px",
                        wordBreak: "break-word",
                      }}
                    >
                      {ele}
                    </li>
                  ))}
                </ul>
              </div>
            ) : Array.isArray(alertMessage) ? (
              <div
                style={{
                  maxWidth: "460px",
                  margin: "0 auto",
                }}
              >
                <ol
                  style={{
                    margin: 0,
                    paddingLeft: "24px",
                    lineHeight: 1.8,
                  }}
                >
                  {alertMessage.map((msg, idx) => (
                    <li key={idx}>
                      {msg.split(/('.*?')/).map((part, i) =>
                        /^'.*'$/.test(part) ? (
                          <strong key={i}>{part.slice(1, -1)}</strong>
                        ) : (
                          <span key={i}>{part}</span>
                        )
                      )}
                    </li>
                  ))}
                </ol>
              </div>
            ) : (
              <p
                style={{
                  margin: 0,
                  textAlign: "center",
                  lineHeight: 1.6,
                }}
              >
                {alertMessage}
              </p>
            )}
          </CustomDialog>
        </Box>

        {/* <Grid
          sx={{
            height: "100%",
            width: "5%",
            margin: "5px",
          }}
        >
          <div
            style={{
              height: "100%",
              background: containerBackgroundColor,
              marginTop: "1rem",
              borderRadius: "2%",
            }}
          >
            <Item
              sx={{
                height: "100%",
              }}
            >
              <UserRoleToolbox
                displayHomePage={displayHomePage}
                displayTrackNowFilingMasterList={
                  displayTrackNowFilingMasterList
                }
                displayPostAwardFilingMasterList={
                  displayPostAwardFilingMasterList
                }
                displayClientFilingTrackerList={displayClientFilingTrackerList}
                displayHistory={displayHistory}
                handleClose={closeHistory}
              />
            </Item>
          </div>
        </Grid> */}
      </Box>
      {
        <UserRoleSetupHistory
          show={showHistory}
          dockAt="right"
          customerList={customerList}
          roleList={roleList}
          //tracker={selectedmasters}
          //  commentActivityHistory={commentActivityHistory}
          selectedUserRow={selectedUserRow}
          activityHistory={activityHistory}
          handleClose={closeHistory}
        />
      }
    </Fragment>
  );
}
